import React from 'react';
import { AlertCircle, ClipboardCopy } from 'lucide-react';
import { APP_VERSION } from '@/utils/appVersion';
import { useCopyDiagnostics } from '@/hooks/useCopyDiagnostics';

interface ErrorReportingFABProps {
    onClick: () => void;
}

const ErrorReportingFAB: React.FC<ErrorReportingFABProps> = ({ onClick }) => {
    // #1304: one-click diagnostics (build id, UA, online, route) so support can
    // tell instantly whether a beta user is on a stale bundle.
    const handleCopyDiagnostics = useCopyDiagnostics();

    return (
        // BD-4: hidden while a dialog is open, so it never sits on a modal's corner.
        // V05: also hidden where page chrome docks the same actions
        // (data-diagnostics-docked: Sidebar, onboarding footer) — floating, it
        // covered bottom-right commands (mobile quick actions, sticky save bars,
        // onboarding Next). It stays the fallback on surfaces without chrome.
        <div className="fixed bottom-[calc(1.5rem+env(safe-area-inset-bottom))] right-[calc(1.5rem+env(safe-area-inset-right))] z-50 flex flex-col items-end gap-2 [body:has([role=dialog])_&]:hidden [body:has([data-diagnostics-docked])_&]:hidden">
            <button
                type="button"
                onClick={handleCopyDiagnostics}
                className="p-2 bg-gray-700 text-white rounded-full shadow hover:bg-gray-800 transition-all duration-300 flex items-center justify-center"
                aria-label="Copy diagnostics"
                title={`Copy diagnostics for support (build ${APP_VERSION})`}
            >
                <ClipboardCopy size={16} />
            </button>
            <button
                type="button"
                onClick={onClick}
                className="p-4 bg-red-600 text-white rounded-full shadow-lg hover:bg-red-700 transition-all duration-300 flex items-center justify-center group"
                aria-label="Report an error"
                title={`Report an error or provide feedback (build ${APP_VERSION})`}
            >
                <AlertCircle size={24} className="group-hover:scale-110 transition-transform" />
            </button>
        </div>
    );
};

export default ErrorReportingFAB;
